import { Reducer } from "react";
import { AuthAction } from "./authAction";

export interface AuthState {
  isLoggedIn?: boolean;
  authToken?: string;
  userId?: string;
  name?: string;
  username?: string;
  roles?: string[]
};

export const defaultAuthState: AuthState = {
  isLoggedIn: undefined,
};

const authReducer: Reducer<AuthState, AuthAction> = (state, action) => {
  console.log('action',action.payload)
  // user successfully authenticated
  if (action.type === "LOG_IN") {
    localStorage.setItem("user", JSON.stringify(action.payload));
    return {
      ...state,
      isLoggedIn: true,
      authToken: action.payload.authToken,
      userId: action.payload.userId,
      name: action.payload.name,
      username: action.payload.username,
      roles: action.payload.roles,
      groups:action.payload.groups,
    };
  }

  // log out user
  if (action.type === "LOG_OUT") {
    localStorage.removeItem("user");
    return defaultAuthState;
  }

  return defaultAuthState;
};

export default authReducer;